import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { ClienteAnaliseMercadoStatusProjetado, statusProjetados, statusProjetadoNaoProjetado, statusProjetadoProjetado, statusProjetadoEmNegociacao, statusProjetadoGanho, statusProjetadoPerdido } from '../cliente-analise-mercado-status-projetado';
import { ClienteAnaliseMercadoStatusProjetadoPipe } from '../pipes';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-projetado-multiselect',
    templateUrl: './cliente-analise-mercado-status-projetado-multiselect.component.html',
    styleUrls: ['./cliente-analise-mercado-status-projetado-multiselect.component.less']
})
export class ClienteAnaliseMercadoStatusProjetadoMultiselectComponent implements OnInit {
    /** Status projetados selecionados */
    @Input() statusProjetados: number[];
    /** Ao alterar a seleção dos status */
    @Output() statusProjetadosChange = new EventEmitter<number[]>();

    @Input() disabled = false;

    // Settings
    settings: IMultiSelectSettings = {
        pullRight: true,
        enableSearch: true,
        containerClasses: 'container-multiselect container-multiselect-cliente-analise-mercado-status-projetado',
        showCheckAll: true,
        showUncheckAll: true,
        dynamicTitleMaxItems: 0
    }
    // Texts
    texts: IMultiSelectTexts = {
        checkAll: 'Selecionar todos',
        uncheckAll: 'Limpar',
        checked: 'status',
        checkedPlural: 'status',
        searchPlaceholder: 'Pesquisar...',
        defaultTitle: 'Status',
        allSelected: 'Todos selecionados',
        searchEmptyResult: 'Nenhum status encontrado',
        searchNoRenderText: 'Digite para pesquisar'
    }
    // Options
    options: IMultiSelectOption[];

    constructor(private clienteAnaliseMercadoStatusProjetadoPipe: ClienteAnaliseMercadoStatusProjetadoPipe) { }

    ngOnInit() {
        this.create();
    }

    /** Cria os status projetados para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];
        statusProjetados.forEach(status => {
            selects.push({
                id: status.id,
                name: this.clienteAnaliseMercadoStatusProjetadoPipe.transform(status.id),
                classes: this.getMultiselectItemClasses(status)
            });
        });
        this.options = selects;
    }

    /** Obtem as classes CSS para o item do multiselect do status */
    private getMultiselectItemClasses(status: ClienteAnaliseMercadoStatusProjetado): string {
        switch (status) {
            case statusProjetadoNaoProjetado:
                return 'multiselect-item-cliente-analise-mercado-status-projetado multiselect-item-cliente-analise-mercado-status-projetado-nao-projetado';
            case statusProjetadoProjetado:
                return 'multiselect-item-cliente-analise-mercado-status-projetado multiselect-item-cliente-analise-mercado-status-projetado-projetado';
            case statusProjetadoEmNegociacao:
                return 'multiselect-item-cliente-analise-mercado-status-projetado multiselect-item-cliente-analise-mercado-status-projetado-em-negociacao';
            case statusProjetadoGanho:
                return 'multiselect-item-cliente-analise-mercado-status-projetado multiselect-item-cliente-analise-mercado-status-projetado-ganho';
            case statusProjetadoPerdido:
                return 'multiselect-item-cliente-analise-mercado-status-projetado multiselect-item-cliente-analise-mercado-status-projetado-perdido';
            default:
                break;
        }
    }

    /** Ao alterar a seleção dos status */
    onChange() {
        this.statusProjetadosChange.emit(this.statusProjetados);
    }
}
